var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 95,
    viewBox: "0 0 102 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71907 34.1171V28.6063L14.5285 25.8008V31.3617L9.71907 34.1171Z",
    fill: "#FF847C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71906 34.1174L5.7112 31.7628V26.252L9.71906 28.6066V34.1174Z",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71906 28.6061L5.7112 26.2515L10.5206 23.4961L14.5285 25.8006L9.71906 28.6061Z",
    fill: "#E9EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91943 26.1499L5.91158 23.7953V22.3926L9.91943 24.7472V26.1499Z",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8713 5.75977L14.8792 8.11438C15.3801 8.41497 15.6306 9.01615 15.6306 9.81772C15.6306 13.8256 9.91943 17.5329 9.91943 24.7971L5.91158 22.4425C5.91158 15.1782 11.6228 11.471 11.6228 7.46311C11.5727 6.61144 11.3222 6.01026 10.8713 5.75977Z",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.278 0.450054L18.2859 2.80467C16.9833 2.0031 14.9293 2.20349 12.3242 3.70644L8.31631 1.35182C10.9214 -0.101027 12.9754 -0.351518 14.278 0.450054Z",
    fill: "#E9EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10806 17.3831L0.100196 15.0285C0.0500982 15.0285 0 14.9784 0 14.8281L4.00786 17.1827C4.00786 17.2829 4.05796 17.3831 4.10806 17.3831Z",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3242 3.70593C17.0835 0.950525 19.9892 2.50357 19.9892 6.51143C19.9892 13.6755 14.278 16.481 14.278 22.1922V23.5949L9.86937 26.1499V24.7472C9.86937 17.4829 15.5806 13.7757 15.5806 9.76781C15.5806 8.11457 14.4283 7.313 12.4244 8.46526C10.4204 9.61752 8.76721 11.8218 8.31632 14.6774C8.26622 15.0281 8.21613 15.1283 7.96563 15.2786L4.35856 17.3827C4.10807 17.4829 4.00787 17.4328 4.00787 17.1323C4.15817 12.7737 7.11396 6.71182 12.3242 3.70593Z",
    fill: "#FF847C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00786 17.1325L0 14.7779C0.100196 11.6718 1.60314 7.71404 4.35855 4.60795C5.46071 3.35549 6.81336 2.20323 8.31631 1.35156L12.3242 3.70618C10.8212 4.55785 9.46857 5.71011 8.36641 7.01266C5.611 10.1188 4.10806 14.0264 4.00786 17.1325Z",
    fill: "#E9EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3664 7.01214C5.611 10.1182 4.10805 14.0259 4.00786 17.132L0 14.7774C0.100196 11.6713 1.60314 7.71351 4.35855 4.60742",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46268 33.8672L6.31239 74.0961L41.331 94.3358L41.4813 54.0568L6.46268 33.8672Z",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.331 94.3358L76.1493 74.0961L76.2495 33.8672L41.4813 54.0568L41.331 94.3358Z",
    fill: "#6C65F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4819 54.0562L76.2501 33.8666L41.2314 13.627L6.46324 33.8666L41.4819 54.0562Z",
    fill: "#E9EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3084 46.0408L63.1739 41.4318L28.1552 21.2422L20.2898 25.8011L55.3084 46.0408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3084 86.2195L63.1738 81.6104V41.4316L55.3084 46.0407V86.2195Z",
    fill: "#D2D2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4705 42.7852V60.1692L19.5383 65.4296L19.5884 48.0956L10.4705 42.7852Z",
    fill: "#7E709B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1208 79.4051V71.4395L94.0845 67.4316V75.3973L87.1208 79.4051Z",
    fill: "#FF847C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1208 79.4062L81.3094 76.0496V68.084L87.1208 71.4406V79.4062Z",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1208 71.4399L81.3094 68.0833L88.2731 64.0254L94.0845 67.4321L87.1208 71.4399Z",
    fill: "#E9EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4214 67.8833L81.61 64.5267V62.4727L87.4214 65.8292V67.8833Z",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7741 38.4258L94.5854 41.7824C95.2868 42.1832 95.6876 43.0849 95.6876 44.1871C95.6876 49.9985 87.4214 55.3089 87.4715 65.8295L81.6601 62.4729C81.61 51.9523 89.9263 46.6419 89.8762 40.8305C89.8261 39.6782 89.4754 38.8266 88.7741 38.4258Z",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7338 30.7104L99.5452 34.067C97.6415 32.9648 94.6857 33.2654 90.9283 35.4196L85.1169 32.063C88.8743 29.9088 91.8301 29.6082 93.7338 30.7104Z",
    fill: "#E9EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0049 55.2593L73.1935 51.9027C73.0933 51.8526 73.0933 51.7524 73.0933 51.502L78.9047 54.8585C78.8546 55.109 78.9047 55.2092 79.0049 55.2593Z",
    fill: "#23005B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8782 35.4698C97.7416 31.512 101.95 33.7163 101.95 39.4776C102 49.7979 93.6837 53.9059 93.7338 62.1721V64.2261L87.3713 67.8833V65.8293C87.3212 55.3087 95.6375 49.9982 95.5874 44.1869C95.5874 41.7821 93.9342 40.6299 91.0285 42.2831C88.1228 43.9865 85.7682 47.1427 85.0668 51.2507C84.9666 51.7016 84.9165 51.9521 84.5658 52.1525L79.3556 55.1584C79.0049 55.3588 78.8546 55.2586 78.8546 54.8578C79.055 48.5454 83.3634 39.7782 90.8782 35.4698Z",
    fill: "#FF847C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8546 54.908L73.0432 51.5514C73.1935 47.0426 75.3978 41.3314 79.3556 36.8726C80.9587 35.019 82.9126 33.4158 85.0668 32.1133L90.8782 35.4699C88.6739 36.7223 86.7701 38.3756 85.1169 40.2292C81.2092 44.6879 79.0049 50.3991 78.8546 54.908Z",
    fill: "#E9EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.167 40.2296C81.2092 44.6884 79.0049 50.3996 78.8546 54.9084L73.0432 51.5518C73.1935 47.043 75.3978 41.3318 79.3556 36.873",
    fill: "#23005B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 94.335,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrder);
export default __webpack_public_path__ + "static/media/no-order.105727af713fe42e099931e259d37b4e.svg";
export { ForwardRef as ReactComponent };